import React from "react";
import Logo from "./Logo";
import loadingLogo from "../img/infinity.json";

const Loading = () => <Logo link={loadingLogo} />;

export default Loading;
